import listActions from './listActions';

const emailOrderActions = {};

emailOrderActions.sendEmailStart = (orderID) => ({
  type: listActions.SEND_EMAIL_ORDER_START,
  orderID,
});

emailOrderActions.sendEmailSuccess = (orderID) => ({
  type: listActions.SEND_EMAIL_ORDER_SUCCESS,
  orderID,
});

emailOrderActions.sendEmailFail = (orderID, error) => ({
  type: listActions.SEND_EMAIL_ORDER_FAIL,
  orderID,
  error,
});

export default emailOrderActions;



// WEBPACK FOOTER //
// ./src/store/actions/emailOrderActions.js